import React from 'react'
import styles from './productCardGhost.module.scss'

export const ProductCardGhost: React.FC = React.memo(() => (
  <div className={styles.ghost} />
))

ProductCardGhost.displayName = 'ProductCardGhost'
